"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listLog = listLog;
exports.createCtiLog = createCtiLog;
exports.drmLog = drmLog;

var _request = _interopRequireDefault(require("@/utils/request"));

function listLog(query) {
  return (0, _request.default)({
    url: '/log/list',
    method: 'get',
    params: query
  });
}

function createCtiLog(type, code, log) {
  var data = {
    eventType: type,
    eventCode: code,
    eventLog: log
  };
  return (0, _request.default)({
    url: '/log/createCtiLog',
    method: 'post',
    data: data
  });
}

function drmLog(query) {
  return (0, _request.default)({
    url: '/log/drmList',
    method: 'get',
    params: query
  });
}